import ruRU from './ru_RU'

export default {
  tagsView: {
    refresh: 'Обновить',
    close: 'Закрыть',
    closeOthers: 'Закрыть другие',
    closeAll: 'Закрыть все'
  },
  ...ruRU,
  ETD: 'ETD',
  ETA: 'ETA',
  i18nDemo: {
    message: 'Это русское сообщение',
    btnDesc: 'Русская кнопка',
    messageBtn: 'Нажмите, чтобы увидеть сообщение'
  },
  baseInfo: {
    seaport: {
      tabPort: {
        tabName: 'Порт'
      },
      tabEdiPort: {
        tabName: 'EDI Порт',
        shipCompany: 'Судоходная компания',
        originPortCode: 'Исходный код порта',
        currentPortCode: 'Текущий код порта',
        shipCompanyCheck: 'Пожалуйста, выберите судоходную компанию!',
        originPortCodeCheck: 'Пожалуйста, выберите порт!',
        currentPortCodeCheck: 'Пожалуйста, введите 5-значный код порта!'
      },
      tabAmsPort: {
        tabName: 'AMS Порт',
        amsPortMaintain: 'Обслуживание порта AMS',
        usNo: 'US NO',
        englishName: 'Название на английском',
        unNo: 'UN NO',
        country: 'Страна',
        remark: 'Примечание',
        usNoCheck: 'Пожалуйста, введите правильный US NO.',
        englishNameCheck: 'Название на английском не может быть пустым.',
        unNoCheck: 'Пожалуйста, введите правильный UN NO.',
        countryCheck: 'Страна не может быть пустой.'
      }
    },
    city: {
      code: 'Код',
      chineseName: 'Название на китайском',
      englishName: 'Название на английском',
      locationCode: 'Код города',
      country: 'Страна',
      addBaseCity: 'Добавить базовый город',
      codeCheck: 'Код не может быть пустым!',
      englishNameCheck: 'Название на английском не может быть пустым!',
      countryCheck: 'Пожалуйста, выберите страну!',
      lon: 'Долгота',
      lat: 'Широта'
    },
    overseaWarehouse: {
      warehouseCode: 'Код склада',
      countryChineseName: 'Название на китайском',
      countryEnglishName: 'Название на английском',
      country: 'Страна',
      province: 'Область',
      city: 'Город',
      zipCode: 'Почтовый индекс',
      address: 'Подробный адрес',
      address1: 'Адрес 1',
      address2: 'Адрес 2',
      address3: 'Адрес 3',
      ifFba: 'Amazon склад',
      entryRequirements: 'Требования к входу',
      warehouseAgeCalculationRules: 'Правила расчета возраста склада',
      warehouseAgeCalculationRulesEdit: 'Правила расчета возраста склада (недели)',
      btn: {
        newFbaWarehouse: 'Добавить склад Amazon',
        newOverseaWarehouse: 'Добавить зарубежный склад'
      },
      msg: {
        warehouseNoEmpty: 'Код склада не может быть пустым',
        countryNoEmpty: 'Страна не может быть пустой',
        cityNoEmpty: 'Город не может быть пустым',
        zipCodeNoEmpty: 'Почтовый индекс не может быть пустым',
        addressNoEmpty: 'Адрес не может быть пустым',
        chineseNameNoEmpty: 'Название на китайском не может быть пустым',
        englishNameNoEmpty: 'Название на английском не может быть пустым',
        warehouseAgeCalculationRulesNoEmpty: 'Правила расчета возраста склада не могут быть пустыми',
        unSelectFbaWarehouse: 'Склад FBA не выбран',
        canNotEditFbaWarehouse: 'Невозможно редактировать склад Amazon',
        duplicateAddition: '{0} уже добавлен, нельзя добавить повторно',
        warehouseNoLen: 'Длина кода зарубежного склада не может превышать 16 символов'
      }
    },
    basicData: {
      continent: {
        code: 'Код',
        name: 'Название',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!'
      },
      region: {
        code: 'Код',
        name: 'Название на китайском',
        nameEnglish: 'Название на английском',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название на китайском не может быть пустым!'
      },
      mscService: {
        serviceCode: 'Код услуги',
        serviceName: 'Название услуги',
        serviceCodeCheck: 'Код услуги не может быть пустым!',
        serviceNameCheck: 'Название услуги не может быть пустым!'
      },
      network: {
        code: 'Код сети',
        name: 'Название сети',
        codeCheck: 'Код сети не может быть пустым!',
        nameCheck: 'Название сети не может быть пустым!'
      },
      currency: {
        serialNumber: 'Порядковый номер',
        code: 'Код',
        name: 'Название',
        localName: 'Локализованное название',
        interchangeCode: 'Код обмена',
        isoCode: 'ISO код',
        defaultFractionDigits: 'Количество десятичных знаков',
        symbol: 'Символ',
        remarks: 'Примечания',
        addBaseCurrency: 'Добавить базовую валюту',
        serialNumberCheck: 'Порядковый номер не может быть пустым!',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!',
        interchangeCodeCheck: 'Код обмена не может быть пустым!',
        isoCodeCheck: 'ISO код не может быть пустым!',
        defaultFractionDigitsCheck: 'Количество десятичных знаков не может быть пустым!',
        carryRule: 'Правило округления валюты',
        rounding: 'Округление',
        truncation: 'Отсечение'
      },
      eqType: {
        code: 'Код',
        name: 'Название',
        localName: 'Локализованное название',
        remark: 'Примечание',
        addBaseEQType: 'Добавить базовый тип оборудования',
        codeCheck: 'Код не может быть пустым!'
      },
      packing: {
        serialNumber: 'Порядковый номер',
        code: 'Код',
        name: 'Название',
        englishName: 'Название на английском',
        chineseName: 'Название на китайском',
        interchangeCode: 'Код обмена',
        isoCode: 'ISO код',
        position: 'Позиция',
        ediCode: 'EDI код',
        addBasePacking: 'Добавить базовую упаковку',
        serialNumberCheck: 'Порядковый номер не может быть пустым!',
        codeCheck: 'Код не может быть пустым!',
        interchangeCodeCheck: 'Код обмена не может быть пустым!',
        isoCodeCheck: 'ISO код не может быть пустым!',
        positionCheck: 'Позиция не может быть пустой!',
        userDefinedField: 'Пользовательское поле'
      },
      orderFormType: {
        code: 'Код',
        name: 'Название',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!'
      },
      cargoType: {
        code: 'Код',
        chineseName: 'Название на китайском',
        englishName: 'Название на английском',
        sea: 'Используется для морских перевозок',
        air: 'Используется для авиаперевозок',
        fbaSea: 'Используется для FBA морских перевозок',
        fbaAir: 'Используется для FBA авиаперевозок',
        fbaRailway: 'Используется для FBA железнодорожных перевозок',
        codeCheck: 'Код не может быть пустым!',
        chineseNameCheck: 'Название на китайском не может быть пустым!'
      },
      incoTerm: {
        serialNumber: 'Порядковый номер',
        code: 'Код',
        name: 'Название',
        localName: 'Локализованное название',
        interchangeCode: 'Код обмена',
        isoCode: 'ISO код',
        remark: 'Примечание',
        addBaseIncoTerm: 'Добавить базовые условия поставки',
        serialNumberCheck: 'Порядковый номер не может быть пустым!',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!',
        interchangeCodeCheck: 'Код обмена не может быть пустым!',
        isoCodeCheck: 'ISO код не может быть пустым!'
      },
      shippingTerm: {
        serialNumber: 'Порядковый номер',
        code: 'Код',
        name: 'Название',
        localName: 'Локализованное название',
        interchangeCode: 'Код обмена',
        isoCode: 'ISO код',
        remark: 'Примечание',
        addBaseShippingTerm: 'Добавить базовые условия перевозки',
        serialNumberCheck: 'Порядковый номер не может быть пустым!',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!',
        interchangeCodeCheck: 'Код обмена не может быть пустым!',
        isoCodeCheck: 'ISO код не может быть пустым!',
        defaultContainerLoadType: 'Тип загрузки контейнера по умолчанию',
        defaultShow: 'Показывать по умолчанию',
        operationTypeTip: '※После настройки при создании морских импортных/экспортных операций поле условий перевозки для основного/дополнительного коносамента будет показывать эти условия перевозки по умолчанию'
      },
      paymentTerm: {
        serialNumber: 'Порядковый номер',
        code: 'Код',
        name: 'Название',
        localName: 'Локализованное название',
        interchangeCode: 'Код обмена',
        isoCode: 'ISO код',
        remark: 'Примечание',
        addBasePaymentTerm: 'Добавить базовые условия оплаты',
        serialNumberCheck: 'Порядковый номер не может быть пустым!',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!',
        interchangeCodeCheck: 'Код обмена не может быть пустым!',
        isoCodeCheck: 'ISO код не может быть пустым!'
      },
      tradeTerm: {
        serialNumber: 'Порядковый номер',
        code: 'Код',
        name: 'Название на китайском',
        localName: 'Локализованное название',
        englishName: 'Название на английском',
        interchangeCode: 'Код обмена',
        isoCode: 'ISO код',
        remark: 'Примечание',
        addBaseTradeTerm: 'Добавить базовый торговый термин',
        serialNumberCheck: 'Порядковый номер не может быть пустым!',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!',
        interchangeCodeCheck: 'Код обмена не может быть пустым!',
        isoCodeCheck: 'ISO код не может быть пустым!'
      },
      priceAirService: {
        code: 'Код',
        chineseName: 'Название на китайском',
        englishName: 'Название на английском',
        codeCheck: 'Код не может быть пустым!',
        chineseNameCheck: 'Название на китайском не может быть пустым!'
      },
      portGroup: {
        portCode: 'Код порта',
        groupCode: 'Группа портов',
        portCodeCheck: 'Код порта не может быть пустым!',
        groupCodeCheck: 'Группа портов не может быть пустой!'
      },
      otherChargeItem: {
        chargeItemCode: 'Код',
        chineseName: 'Название на китайском',
        measure: 'Способ расчета',
        defaultApPrice: 'Цена по умолчанию',
        remark: 'Примечание',
        chargeWeight: 'По весу',
        wt: 'По брутто',
        job: 'По количеству',
        chargeItemCodeCheck: 'Код не может быть пустым!',
        chineseNameCheck: 'Название на китайском не может быть пустым!'
      },
      customerType: {
        typeId: 'Уровень',
        chineseName: 'Название на китайском',
        englishName: 'Название на английском',
        typeIdCheck: 'Уровень не может быть пустым!',
        chineseNameCheck: 'Название на китайском не может быть пустым!',
        englishNameCheck: 'Название на английском не может быть пустым!'
      },
      appraisalCategory: {
        serialNumber: 'Порядковый номер',
        serialNumberCheck: 'Порядковый номер не может быть пустым',
        code: 'Код',
        codeCheck: 'Код не может быть пустым',
        chineseName: 'Название на китайском',
        englishName: 'Название на английском',
        chineseNameCheck: 'Название на китайском не может быть пустым!',
        englishNameCheck: 'Название на английском не может быть пустым!'
      },
      blMode: {
        serialNumber: 'Порядковый номер',
        code: 'Код',
        name: 'Название',
        localName: 'Локализованное название',
        interchangeCode: 'Код обмена',
        isoCode: 'ISO код',
        blType: 'Тип коносамента',
        remark: 'Примечание',
        addBaseBlMode: 'Добавить режим коносамента',
        serialNumberCheck: 'Порядковый номер не может быть пустым!',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!',
        interchangeCodeCheck: 'Код обмена не может быть пустым!',
        isoCodeCheck: 'ISO код не может быть пустым!'
      },
      cutomJobType: {
        serialNumber: 'Порядковый номер',
        code: 'Код',
        name: 'Название',
        localName: 'Локализованное название',
        englishName: 'Название на английском',
        type: 'Тип операции',
        remarks: 'Примечания',
        containerLoadType: 'Режим операции',
        addBaseBlMode: 'Добавить базовый торговый термин',
        serialNumberCheck: 'Порядковый номер не может быть пустым!',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название не может быть пустым!',
        englishNameCheck: 'Название на английском не может быть пустым!',
        typeCheck: 'Тип операции не может быть пустым!',
        interchangeCode: 'Код обмена',
        codeTips1: '*Формат кода: буквы и цифры, максимум 4 символа.',
        codeTips2: 'Длина кода превышает лимит, пожалуйста, введите заново!',
        codeTips3: 'Неверный формат кода, пожалуйста, введите заново!',
        codeTips4: '*Формат кода: буквы, цифры и комбинации, максимум 10 символов.'
      },
      chargeUnit: {
        codeCheck: 'Код не может быть пустым!',
        chineseNameCheck: 'Название на китайском не может быть пустым!',
        englishNameCheck: 'Название на английском не может быть пустым!',
        chargeUnitAndUnitCheck: 'Необходимо выбрать хотя бы один тип единицы измерения для отображения!',
        seaFreightAndAirFreightCheck: 'Необходимо выбрать хотя бы один тип перевозки (морской или воздушный)!',
        businessTypeCheck: 'Необходимо выбрать хотя бы один тип бизнеса (морской, воздушный, FBA морской, FBA воздушный, FBA железнодорожный)!',
        fbaSeaAndAirAndRailwayCheck: 'Необходимо выбрать хотя бы один тип перевозки (морской, воздушный или железнодорожный)!'
      },
      dangerousGoods: {
        codeCheck: 'Пожалуйста, введите номер ООН'
      },
      cargoInformation: {
        codeCheck: 'Код не может быть пустым!',
        chineseNameCheck: 'Название на китайском не может быть пустым!',
        englishNameCheck: 'Название на английском не может быть пустым!'
      },
      propulsionType: {
        codeCheck: 'Название не может быть пустым!'
      },
      baseCustomsDeclarationType: {
        code: 'Код',
        name: 'Название на китайском',
        englishName: 'Название на английском',
        codeCheck: 'Код не может быть пустым!',
        nameCheck: 'Название на китайском не может быть пустым!',
        englishNameCheck: 'Название на английском не может быть пустым!',
        codeTooLong: 'Данные в колонке [Код] слишком длинные',
        nameTooLong: 'Данные в колонке [Название на китайском] слишком длинные',
        englishNameTooLong: 'Данные в колонке [Название на английском] слишком длинные',
        addBaseCustomsDeclarationType: 'Добавить тип таможенной декларации',
        isPlatform: 'Данные платформы',
        PlatformTip: 'Данные платформы нельзя изменять!'
      },
      gpExplainTitle: {
        codeCheck: 'Код не может быть пустым!',
        chineseNameCheck: 'Название на китайском не может быть пустым!',
        englishNameCheck: 'Название на английском не может быть пустым!'
      }
    },
    airport: {
      addBasePort: 'Добавить базовый аэропорт',
      serialNumber: 'Порядковый номер',
      code: 'Код',
      chineseName: 'Название на китайском',
      englishName: 'Название на английском',
      interchangeCode: 'Код обмена',
      isoCode: 'ISO код',
      countryCode: 'Страна',
      region: 'Регион',
      requirement: 'Требования аэропорта',
      whetherToAdd: 'Добавлено ли',
      portAdd: 'Добавление аэропорта',
      portEdit: 'Редактирование аэропорта',
      cityName: 'Название города',
      cityCode: 'Код города',
      codeCheck: 'Пожалуйста, введите правильный код аэропорта',
      interchangeCodeCheck: 'Код обмена не может быть пустым',
      isoCodeCheck: 'ISO код не может быть пустым',
      englishNameCheck: 'Название на английском не может быть пустым'
    },
    operation: {
      operationType: 'Тип операции',
      lobType: 'Тип бизнеса',
      code: 'Код',
      lob: 'Тип бизнеса',
      operationRequirementType: 'Тип операционных требований',
      contentDescription: 'Код/описание содержимого',
      operationMaintain: 'Обслуживание операционных требований',
      remark: 'Примечание',
      enterContentDescription: 'Пожалуйста, введите код или описание содержимого'
    },
    customsCommodityCode: {
      code: 'Код товара',
      commodityName: 'Наименование товара',
      mfnRate: 'Ставка НБН',
      generalRate: 'Общая ставка',
      vat: 'НДС',
      legalUnit: 'Законная единица измерения',
      mscCommodity: 'Наименование товара на английском (MSC)',
      secondUnit: 'Вторая единица измерения',
      superviseMode: 'Режим контроля',
      customsCommodityCodeMaintain: 'Обслуживание кода таможенного товара',
      countryCode: 'Код страны',
      countryCodeCheck: 'Код страны не может быть пустым. ',
      codeCheck: 'Код товара не может быть пустым. ',
      commodityNameCheck: 'Наименование товара не может быть пустым.'
    },
    usCommodityCode: {
      systemCode: 'Системный код',
      tradeName: 'Торговое наименование',
      productDescription: 'Описание продукта',
      descriptionCode: 'Код описания',
      customsTariff: 'Таможенный тариф',
      additionalTaxRate056: 'Дополнительная ставка 056',
      including499AdditionalTaxRate: 'Включая дополнительную ставку 499',
      including501AdditionalTaxRate: 'Включая дополнительную ставку 501',
      chinaAdditionalTaxRate: 'Дополнительная ставка Китая',
      chinaSurtaxTariff: 'Дополнительный тариф Китая',
      chinaSurtaxClause: 'Дополнительный пункт Китая',
      enable: 'Включить',
      disable: 'Отключить',
      chinaHongKongSurtaxTariff: 'Дополнительный тариф Китая (Гонконг)',
      remark: 'Примечание'
    },
    country: {
      serialNumber: 'Порядковый номер',
      code: 'Код',
      englishName: 'Название на английском',
      chineseName: 'Название на китайском',
      continent: 'Континент',
      interchangeCode: 'Код обмена',
      isoCode: 'ISO код',
      countryMaintain: 'Обслуживание стран'
    },
    rateManagement: {
      copyRate: 'Копировать курс',
      originalCurrency: 'Исходная валюта',
      benchmarkCurrency: 'Базовая валюта',
      rate: 'Курс',
      effectiveMonth: 'Эффективный месяц',
      currentMonth: 'Текущий месяц',
      baseCuurency: 'Базовая валюта',
      currency: 'Исходная валюта',
      month: 'Эффективный месяц',
      rateMaintain: 'Обслуживание курсов',
      currencyCheck: 'Пожалуйста, введите исходную валюту!',
      rateCheck: 'Пожалуйста, введите курс!',
      rateIsTooLong: 'Курс слишком большой, пожалуйста, измените',
      repeatCheck: 'Обнаружено повторение конфигурации, пожалуйста, измените!',
      repeatCheck2: 'Курс конвертации {0} в {1} имеет повторяющуюся конфигурацию, пожалуйста, измените!',
      copyRateMaintain: 'Копировать курс указанного месяца',
      copyCurrentMonthCheck: 'Нельзя копировать данные текущего месяца, пожалуйста, выберите другой месяц!',
      copyRowDataCheck: 'Нет данных за этот месяц!',
      copyRateSuccess: 'Курс успешно скопирован',
      notFoundRate: 'Не найден курс для валюты {0}, пожалуйста, своевременно обслуживайте соответствующий курс!',
      setRateCacheRange: 'Установить диапазон кэширования курса',
      setRateCacheRangeNote: 'Установить диапазон кэширования курса на 18-36 месяцев',
      setRateCacheRangePrefix: 'Кэширование на',
      setRateCacheRangeSuffix: 'месяцев'
    },
    partner: {
      companyName: 'Партнер',
      companyType: 'Тип клиента',
      customerTypeId: 'Уровень клиента',
      remarks: 'Дополнительные примечания',
      approvedState: 'Статус одобрения',
      volume: 'Количество',
      cmpIdx: 'Индекс',
      shortName: 'Краткое название',
      cnShortName: 'Код',
      region: 'Страна',
      area: 'Регион',
      chineseName: 'Название на китайском',
      englishName: 'Название на английском',
      contractStatus: 'Статус контракта',
      branchId: 'Филиал',
      approvedBy: 'Одобрено',
      dateApproved: 'Дата одобрения',
      createBy: 'Создано',
      dateType: 'Тип даты',
      controlSetting: 'Настройка контроля по типу даты',
      creditDateType: 'Способ расчета',
      blacklist: 'Черный список',
      cargoSource: 'Тип груза',
      receivableDeposit: 'Тип поступлений',
      accountingPeriod: 'Период учета',
      quota: 'Квота',
      creditQuota: 'Кредитная квота',
      creditCurrency: 'Кредитная валюта',
      payment: 'Оплата',
      supplierDirector: 'Ответственный поставщика',
      dateCreated: 'Дата создания',
      modifiedBy: 'Изменено',
      dateModified: 'Дата изменения',
      isActive: 'Активно',
      relateTenantUuid: 'Электронный клиент',
      sales: 'Продажи',
      freightVolume30: '30 дней (количество)',
      freightVolume60: '60 дней (количество)',
      freightVolume90: '90 дней (количество)',
      freightVolumeGt90: 'Более 90 дней (количество)',
      basicInfo: {
        title: 'Основная информация',
        relatedBusinessType: 'Связанный тип бизнеса',
        scac: 'SCAC',
        province: 'Провинция',
        city: 'Город',
        district: 'Район'
      }
    },
    mailingAddress: {
      office: 'Филиал',
      lobType: 'Тип бизнеса',
      partner: 'Клиент/Зарубежный агент',
      podName: 'Название порта назначения',
      shipperCode: 'Код отправителя',
      shipperInfo: 'Информация об отправителе',
      consigneeCode: 'Код получателя',
      consigneeInfo: 'Информация о получателе',
      notifyCode: 'Код уведомляемой стороны',
      notifyInfo: 'Информация об уведомляемой стороне',
      shipperName: 'Название отправителя',
      consigneeName: 'Название получателя',
      notifyName: 'Название уведомляемой стороны',
      partner1: 'Клиент',
      pod1: 'Порт назначения',
      formatManifestInfo: 'Форматировать информацию манифеста',
      shipper: 'Отправитель',
      shipperEnterpriseCode: 'Код предприятия отправителя',
      shortCode: 'Краткий код',
      enterpriseCode: 'Код предприятия',
      shipperEnterpriseName: 'Название предприятия отправителя',
      shipperAddress: 'Подробный адрес отправителя',
      cityName: 'Название города',
      provinceCode: 'Код провинции',
      provinceName: 'Название провинции',
      zipCode: 'Почтовый индекс',
      countryCode: 'Код страны',
      aeoEnterpriseCode: 'Код предприятия AEO',
      syncFormatInfoToOrder: 'Синхр. Форм. в Зак.',
      consignee: 'Получатель',
      instructBill: 'Ордерный коносамент',
      consigneeEnterpriseCode: 'Код предприятия получателя',
      consigneeEnterpriseName: 'Название предприятия получателя',
      consigneeAddress: 'Подробный адрес получателя',
      consigneeSpecificContactsName: 'Имя конкретного контакта',
      consigneeSpecificContacts: 'Телефон конкретного контакта',
      notify: 'Уведомляемая сторона',
      notifyEnterpriseCode: 'Код предприятия уведомляемой стороны',
      notifyEnterpriseName: 'Название предприятия уведомляемой стороны',
      notifyAddress: 'Подробный адрес уведомляемой стороны',
      shipperPhoneNumber: 'Телефон отправителя',
      shipperEmail: 'Email отправителя',
      shipperFax: 'Факс отправителя',
      consigneePhoneNumber: 'Телефон получателя',
      consigneeEmail: 'Email получателя',
      consigneeFax: 'Факс получателя',
      consigneeSpecificPhoneNumber: 'Телефон конкретного контакта',
      consigneeSpecificEmail: 'Email конкретного контакта',
      consigneeSpecificFax: 'Факс конкретного контакта',
      notifyPhoneNumber: 'Телефон уведомляемой стороны',
      notifyEmail: 'Email уведомляемой стороны',
      notifyFax: 'Факс уведомляемой стороны',
      addMailingAddress: 'Добавить адрес для переписки',
      editMailingAddress: 'Редактировать адрес для переписки',
      validLobMsg: 'Пожалуйста, выберите код бизнеса.',
      validInstructBill: 'В режиме указания получателя коносамента, код предприятия уведомляемой стороны и контактная информация уведомляемой стороны обязательны.',
      fbaWarehouseCode: 'Код склада Amazon',
      contactName: 'Имя контакта',
      province: 'Провинция/Штат',
      addr1: 'Адрес 1',
      addr2: 'Адрес 2',
      addr3: 'Адрес 3',
      eoriNo: 'EORI/Номер предприятия',
      taxNo: 'Налоговый номер',
      ManifestFormatShipper: 'Форматирование отправителя манифеста',
      TheManifestFormatConsignee: 'Форматирование получателя манифеста',
      ManifestFormatNotifier: 'Форматирование уведомляемой стороны манифеста'
    }
  },
  common: {
    defaultPlaceholder: 'Ключ. слово',
    BeginDate: 'Дата начала',
    EndDate: 'Дата окончания',
    pagePer: 'записей/страница',
    pleaseChoose: 'Пожалуйста, выберите',
    confirm: 'Подтвердить',
    reset: 'Сбросить',
    cancel: 'Отмена',
    tips: {
      fuzzySearch: 'Пожалуйста, введите код, название и т.д. для нечеткого поиска',
      fuzzyCodeSearch: 'Пожалуйста, введите код для нечеткого поиска',
      fuzzyModelSearch: 'Пожалуйста, введите модель для нечеткого поиска',
      overseaWarehouseFuzzySearch: 'Пожалуйста, введите код зарубежного склада для нечеткого поиска',
      hasOneAtleast: 'Пожалуйста, выберите хотя бы одну запись',
      hasOneAtleastAudit: 'Пожалуйста, выберите хотя бы одну проверенную запись',
      hasOneOnly: 'Пожалуйста, выберите только одну запись',
      saveSuccess: 'Успешно сохранено!',
      prompt: 'Подсказка',
      systemPrompt: 'Системное уведомление',
      confirmDelete: 'Подтвердить удаление этой записи?',
      confirmCheck: 'Подтвердить проверку записи?',
      confirmCancelCheck: 'Подтвердить отмену проверки записи?',
      confirm: 'Подтвердить',
      deleteSuccess: 'Успешно удалено!',
      editSuccess: 'Успешно отредактировано!',
      deleteFail: 'Ошибка удаления!',
      cancelDelete: 'Удаление отменено!',
      pleaseChoose: 'Пожалуйста, выберите',
      yes: 'Да',
      no: 'Нет'
    },
    btn: {
      refresh: 'Обновить',
      query: 'Запрос',
      look: 'Просмотр',
      new: 'Создать',
      add: 'Добавить',
      edit: 'Редактировать',
      editAgain: 'Редактировать снова',
      delete: 'Удалить',
      exportExcel: 'Экспорт в Excel',
      downLoadTemplate: 'Скачать шаблон',
      save: 'Сохранить',
      cancel: 'Отмена',
      ok: 'ОК',
      confirm: 'Подтвердить',
      back: 'Назад',
      audit: 'Аудит',
      reject: 'Отклонить',
      reset: 'Сбросить',
      close: 'Закрыть',
      yes: 'Да',
      no: 'Нет',
      next: 'Следующий',
      confirmUpdate: 'Подтвердить обновление',
      enable: 'Включено',
      disable: 'Отключено'
    }
  },
  navbar: {
    screenfull: 'Полный экран',
    logOut: 'Выйти',
    dashboard: 'Главная',
    github: 'GitHub',
    theme: 'Тема',
    size: 'Размер макета'
  },
  login: {
    title: 'Вход в систему',
    logIn: 'Войти',
    username: 'Имя пользователя',
    password: 'Пароль'
  },
  route: {
    dashboard: 'Главная',
    baseInfo: 'Основная информация',
    seaport: 'Морской порт',
    airport: 'Аэропорт',
    airlineCode: 'Код авиакомпании',
    city: 'Город',
    basicData: 'Основные данные',
    country: 'Страна',
    rateManagement: 'Управление курсами валют',
    partner: 'Партнеры',
    seaExport: 'Морской экспорт',
    seaImport: 'Морской импорт',
    airExport: 'Авиа экспорт',
    airImport: 'Авиа импорт',
    railwayExport: 'Желдор. эксп.',
    integratedJob: 'Интегрированная логистика',
    remoteBooking: 'Удальное бронирование',
    prediction: 'Прогноз',
    preBooking: 'Предварительная проверка бронирования',
    operationRequirementDescribe: 'Описание операционных требований',
    customsCommodityCode: 'Таможенный код товара',
    usCommodityCode: 'Код товара США',
    chargeService: 'Платные услуги',
    costPlan: 'План расходов',
    guarantee: 'Гарантия',
    payService: 'Платные услуги',
    mailingAddress: 'Почтовый адрес',
    seaPortRequirement: 'Требования порта (морской)',
    airPortRequirement: 'Требования порта (авиационный)',
    partnerInformationImport: 'Импорт информации о партнёрах',
    bookingNew: 'Бронирование морских перевозок (Экспресс)',
    ProjectManage: 'Управление проектами',
    project: 'Проект',
    order: 'Управление заказами',
    warehousing: 'Управление складом',
    inventory: 'Управление запасами',
    seaImportBooking: 'Операции морских перевозок',
    airExportBooking: 'Бронирование авиаперевозок',
    airImportBooking: 'Операции авиаперевозок',
    preOrder: 'Предварительная проверка заказа'
  },
  sysManage: {
    baseConfig: {
      triggerTypeManagement: {
        addTriggerType: 'Добавить тип триггера',
        editTriggerType: 'Редактировать тип триггера',
        lookTriggerType: 'Просмотр типа триггера',
        validFieldNameMsg: 'Пожалуйста, введите название поля.',
        validFieldEnameMsg: 'Пожалуйста, введите английское название поля.',
        triggerType: 'Тип обновления',
        fieldCheckType: 'Тип проверки поля',
        entityCode: 'Код сущности',
        entityName: 'Название сущности',
        entityEname: 'Английское название сущности',
        fieldCode: 'Код поля',
        fieldName: 'Название поля',
        fieldEname: 'Английское название поля',
        fieldCheckValue: 'Значение проверки поля',
        innerDateState: 'Состояние из внутренних данных',
        outerDateState: 'Состояние из внешних данных',
        applySopNode: 'Применить узел SOP',
        remark: 'Примечание'
      },
      routeWareHouseConfiguration: {
        addRouteWareHouseMapping: 'Добавить конфигурацию маршрута и склада',
        editRouteWareHouseMapping: 'Редактировать конфигурацию маршрута и склада',
        validRegionCodeMsg: 'Пожалуйста, введите код маршрута.',
        validWarehouseMsg: 'Пожалуйста, выберите склад.',
        regionCode: 'Код маршрута',
        warehouse: 'Склад',
        remark: 'Примечание'
      },
      singleOnlineSetting: {
        branchId: 'Филиал',
        fieldCode: 'Код поля',
        fieldName: 'Название поля',
        fclEdit: 'Разрешить редактирование (FCL)',
        lclEdit: 'Разрешить редактирование (LCL)'
      }
    }
  },
  sysMonitor: {
    sopSendLog: {
      orderNo: 'Номер заказа',
      relationId: 'Номер бизнеса',
      dateCreated: 'Время отправки',
      type: 'Тип',
      pushNode: 'Узел отправки',
      pushingChannel: 'Канал отправки',
      pushingResult: 'Результат отправки',
      receivingUser: 'Получатель',
      receivingTxt: 'Описание содержимого',
      modifyDate: 'Время изменения SOP',
      file: 'Файл'
    }
  },
  constant: {
    all: 'Все',
    yes: 'Да',
    no: 'Нет',
    greaterThan: 'Больше',
    lessThan: 'Меньше',
    equal: 'Равно',
    email: 'Email',
    note: 'SMS',
    sop: {
      JOB_NO: 'Номер бизнеса',
      CUSTOMER_ID: 'Заказчик',
      CUSTOMER_ID_CN: 'Заказчик (кит.)',
      CUSTOMER_ID_US: 'Заказчик (англ.)',
      CARRIER_CN: 'Судоходная компания (кит.)',
      CARRIER_US: 'Судоходная компания (англ.)',
      CARRIER_CODE: 'Судоходная компания (код)',
      CARRIER_SHORT_NAME: 'Судоходная компания (краткое название)',
      DESTINATION_AGENT: 'Агент в порту назначения',
      DESTINATION_AGENT_SHORT_NAME: 'Агент в порту назначения (краткое название)',
      DESIGNATION_AGENT: 'Назначенный агент',
      BARGE_POL: 'Порт отправления баржи',
      LOADING_PORT_CODE: 'Порт погрузки',
      LOADING_PORT_CODE3: 'Код порта погрузки',
      DESTINATION_PORT_CODE: 'Порт назначения',
      DESTINATION_PORT_CODE2: 'Код порта назначения',
      VESSEL: 'Название судна',
      VOYAGE: 'Рейс',
      BRANCH_VESSEL: 'Название судна филиала',
      BRANCH_VOYAGE: 'Рейс филиала',
      WAREHOUSE_NO: 'Номер склада',
      SO_NO: 'S/O NO.',
      MBL: 'MB/L NO',
      HBL_NO: 'HB/L NO',
      ETD: 'ETD',
      ETA: 'ETA',
      ATD: 'ATD',
      ATA: 'ATA',
      CUSTOMS_DATE: 'Дата операции',
      CONSIGNEE_CODE: 'Получатель',
      CUSTOMER_REF_NO: 'Ссылочный номер бизнеса',
      USER_DEFINED_FIELD1: 'Пользовательское поле 1',
      USER_DEFINED_FIELD2: 'Пользовательское поле 2',
      USER_DEFINED_FIELD3: 'Пользовательское поле 3',
      USER_DEFINED_FIELD4: 'Пользовательское поле 4',
      ESTIMATED_SHIPPING_DATE: 'Предполагаемая дата отправки',
      CSR: 'Служба поддержки',
      CSR_PHONE: 'Телефон службы поддержки',
      CSR_EMAIL: 'Email службы поддержки',
      OVERSEA_OP_EMAIL: 'Email зарубежной службы поддержки',
      DC_EMAIL: 'Email документов',
      PORT_DISTRICT: 'Район порта',
      TERMINAL_OPENDATE: 'Дата открытия терминала',
      TERMINAL_CUTOFF: 'Дата закрытия терминала',
      REAL_ARRIVALS_DATE: 'Фактическая дата прибытия в порт',
      BERTH_PLAN_DATE: 'Планируемая дата швартовки',
      ACTUAL_BERTH_PLAN_DATE: 'Фактическая дата швартовки',
      UN_BERTH_PLAN_DATE: 'Планируемая дата отшвартовки',
      ACTUAL_UN_BERTH_PLAN_DATE: 'Фактическая дата отшвартовки',
      BERTH_PLAN_PLACE: 'Планируемое место швартовки',
      ACTUAL_BERTH_PLAN_PLACE: 'Фактическое место швартовки',
      OP_EMAIL: 'Email операций',
      DESTINATION_AGENT_EMAIL: 'Email контакта агента в порту назначения по умолчанию',
      SINGLE_ADDRESS: 'Адрес для проверки',
      CUTOFF_TIME: 'Время закрытия',
      EstimatedArrivalTime: 'Предполагаемое время прибытия',
      actualArrivalTime: 'Фактическое время прибытия',
      PortDischargeTime: 'Время выгрузки в порту',
      ActualLiftingDate: 'Фактическая дата подъема',
      ActualReturnTime: 'Фактическое время возврата',
      MBLTransportationClause: 'Условия перевозки основного коносамента',
      HBLTransportationClause: 'Условия перевозки дополнительного коносамента',
      MasterBLFreightTerm: 'Условия фрахта основного коносамента',
      HBLFreightClause: 'Условия фрахта дополнительного коносамента',
      MORE_DOOR_QUANTITY: 'Количество дверей',
      ROUGH_WEIGHT: 'Вес брутто',
      MORE_DOOR_VOLUME: 'Объем дверей',
      PACKAGING_TYPE: 'Тип упаковки',
      SHIPPER_CODE: 'Код отправителя HBL',
      BUSINESS_MODEL: 'Модель бизнеса',
      TICKET_RECEIPT: 'Основной/дополнительный чек',
      NO_LISTING: 'Список номеров контейнеров',
      ESTIMATED_DELIVERY_DATE: 'Предполагаемая дата доставки',
      UNLOADING_WAY: 'Способ выгрузки',
      PO: 'PO',
      CNEE_CODE: 'Код получателя HBL',
      ADDRESS: 'Адрес',
      BASIC_NUMBER: 'Основное количество',
      BASIC_ROUGH_WEIGHT: 'Основной вес брутто',
      BASIC_VOLUME: 'Основной объем',
      DELIVER_DATE: 'Дата доставки',
      ARRIVE_STORAGE_DATE: 'Дата прибытия на склад',
      TRANS_DATE: 'Дата передачи',
      CUSTOMER_REF_NO2: 'Ссылочный номер клиента',
      LOADING_PORT_CODE2: 'Порт погрузки',
      CARRIER_ID: 'Авиакомпания',
      CARRIER_ID_CN: 'Авиакомпания (кит.)',
      CARRIER_ID_US: 'Авиакомпания (англ.)',
      VOYAGE_FLIGHT: 'Рейс',
      ETD2: 'Дата отправления',
      ETA2: 'Дата прибытия',
      WAREHOUSE_NO2: 'Номер склада',
      QUANTITY: 'Количество (на складе)',
      WEIGHT: 'Вес брутто (на складе)',
      VOLUME: 'Объем (на складе)',
      TRANSPORTATION_COMPANY: 'Транспортная компания',
      CONTAINER_NO: 'Номер контейнера',
      SEAL_NO: 'Номер пломбы',
      EMPTY_CABINET_WEIGHT: 'Вес пустого контейнера',
      ESTIMATED_DATE: 'Предполагаемая дата упаковки (на завод)',
      ACTUAL_PACKING: 'Фактическая упаковка (на завод)',
      CONTAINER_DESC: 'Описание контейнеров',
      EXPECTED_ARRIVAL_DATE: 'Предполагаемая дата прибытия',
      ACTUAL_ARRIVAL_DATE: 'Фактическая дата прибытия',
      CUSTOMER_DOOR_POINT: 'Дверь клиента',
      CUSTOMER_PORTAL_ADDRESS: 'Адрес клиента',
      DESTINATION_GATE_POINT: 'Ворота назначения',
      ADDRESS_OF_DESTINATION_GATE_POINT: 'Адрес ворот назначения',
      WAREHOUSE_SUPPLIER: 'Поставщик склада',
      WAREHOUSE_NAME: 'Название склада',
      DOWNLOAD_URL: 'Ссылка для скачивания предварительной записи',
      MBL2: 'MAWB NO',
      HAWB: 'HAWB NO',
      DISCHARGING_PORT: 'Порт выгрузки',
      DISCHARGING_PORT2: 'Код порта выгрузки',
      WAREHOUSE_DATA: 'Данные склада',
      STATUS_UPDATE_TIME: 'Время обновления статуса',
      QUANTITY_CONTRACT: 'Договорное количество',
      WEIGHT_CONTRACT: 'Договорной вес брутто',
      CUBAGE_CONTRACT: 'Договорной объем',
      TRUST_FROM_JOB: 'Ссылочный номер доверенности',
      RELATED_JOB: 'Связанный номер',
      BASIC_SHIPPER_CODE: 'Основной код отправителя',
      BASIC_CONSIGNEE_CODE: 'Основной код получателя',
      INCOTERMS: 'Условия поставки',
      CHARGE_WEIGHT: 'Платный вес',
      PACKAGE: 'Упаковка',
      REMARK: 'Примечание',
      POD: 'Место доставки',
      LOADING_PORT_CODE4: 'Код порта погрузки',
      MBLNO: 'Номер основного коносамента',
      CONTACT: 'Контакт',
      AIR_LINE: 'Авиалиния',
      TRANSPORT_TYPE: 'Тип транспорта',
      DEPARTURE_STATION: 'Станция отправления',
      DEPARTURE_STATION_CODE: 'Код станции отправления',
      DESTINATION_STATION: 'Станция назначения',
      DESTINATION_STATION_CODE: 'Код станции назначения',
      TRANSIT_STATION: 'Станция транзита',
      TRANSIT_STATION_CODE: 'Код станции транзита',
      PAYMENT_METHOD: 'Способ оплаты',
      TRACK_NO: 'Номер отслеживания',
      SHUTTLE: 'Челнок',
      TRAIN_NO: 'Номер поезда',
      QUANTITY_ACTUAL: 'Фактическое количество',
      WEIGHT_ACTUAL: 'Фактический вес брутто',
      CUBAGE_ACTUAL: 'Фактический объем',
      CARGO_CHINESE_NAME_BASE: 'Китайское название груза (основное)',
      CARGO_ENGLISH_NAME_BASE: 'Английское название груза (основное)',
      CARGO_ENGLISH_NAME: 'Английское название груза',
      SALES: 'Продажи',
      SALES_EMAIL: 'Email продаж',
      ACTUAL_PIECE: 'Количество (фактическое)',
      ACTUAL_WEIGHT: 'Вес брутто (фактический)',
      ACTUAL_VOLUME: 'Объем (фактический)',
      CUSTOMER_SERVICE: 'Служба поддержки',
      DOCUMENT: 'Документы',
      ROUTE_MANAGER: 'Менеджер маршрута',
      OVERSEAS_CUSTOMER_SERVICE: 'Зарубежная служба поддержки',
      ROUTE_MANAGER_EMAIL: 'Email менеджера маршрута',
      INTEGRATION_TYPE: 'Тип интеграции',
      ROUTE_LEADER: 'Лидер маршрута',
      ROUTE_LEADER_EMAIL: 'Email лидера маршрута',
      OPERATE: 'Операции',
      MBLCMR: 'Номер основного коносамента',
      DISCHARGING_PLACE: 'Место выгрузки',
      LOADING_PORT: 'Порт погрузки',
      DESTINATION_PORT: 'Порт назначения',
      DOMESTIC_PLATE_NUMBER: 'Внутренний номерной знак',
      KH_PLATE_NUMBER: 'Номерной знак KH',
      KH_TRAILER_NUMBER: 'Номер прицепа KH',
      VOYAGE_FLIGHT_NO: 'Номер рейса',
      BOOKING_DATE: 'Дата бронирования',
      ACTUAL_ENTRY_TIME: 'Фактическое время въезда',
      ACTUAL_LOADING_TIME: 'Фактическое время погрузки',
      ESTIMATED_DEPARTURE_TIME: 'Предполагаемое время отправления',
      ACTUAL_DEPARTURE_TIME: 'Фактическое время отправления',
      ESTIMATED_ARRIVAL_TIME: 'Предполагаемое время прибытия',
      ACTUAL_ARRIVAL_TIME: 'Фактическое время прибытия',
      ACTUAL_RECEIVING_TIME: 'Фактическое время получения',
      ACTUAL_UNLOADING_TIME: 'Фактическое время выгрузки',
      ACTUAL_ARRIVAL_NOTIFICATION_TIME: 'Фактическое время уведомления о прибытии',
      ACTUAL_PICKUP_TIME: 'Фактическое время получения',
      SECOND_FLIGHT: 'Номер рейса (второй этап)',
      ESTIMATED_TRANSFER_ARRIVAL_TIME: 'Предполагаемое время прибытия на пересадку (второй этап)',
      TRANSFER_ARRIVAL_TIME: 'Время прибытия на пересадку (второй этап)',
      ESTIMATED_TRANSFER_DEPARTURE_TIME: 'Предполагаемое время отправления с пересадки (второй этап)',
      TRANSFER_DEPARTURE_TIME: 'Время отправления с пересадки (второй этап)',
      Warehouse_Address: 'Адрес склада',
      Actual_Ship_Date: 'Фактическая дата отправки (ATD)',
      Customs_Brokers: 'Таможенный брокер',
      Actual_Arrival_Date: 'Фактическая дата прибытия (ATA)',
      Actual_Packing_Date: 'Фактическая дата упаковки',
      Door_Point: 'Дверь',
      Additional_Notes: 'Дополнительные примечания',
      Estimated_Delivery_Time: 'Предполагаемое время доставки',
      Actual_Delivery_Time: 'Фактическое время доставки',
      PACKING: 'Упаковка',
      PACKING_CN: 'Упаковка (кит.)',
      PACKING_US: 'Упаковка (англ.)',
      TYPE_OF_GOODS: 'Тип товара',
      TYPE_OF_GOODS_CODE: 'Код типа товара',
      MAIN_PAYMENT_LOCATION: 'Основное место оплаты',
      MARK: 'Маркировка',
      HS_NUMBER: 'Номер HS',
      CUSTOM_POSITION_1: 'Пользовательская позиция 1',
      CUSTOM_POSITION_2: 'Пользовательская позиция 2',
      TRANSIT_PORT: 'Порт транзита',
      BOOKING_NUMBER: 'Номер бронирования',
      SHIPPING_NUMBER: 'Номер судоходной компании',
      BARGES_REMARKS: 'Примечания к барже',
      MBL_SHIPPER: 'Отправитель MB/L',
      MBL_CONSIGNEE: 'Получатель MB/L',
      MBL_NOTIFIER: 'Уведомляемая сторона MB/L'
    },
    nodeType: {
      lodingPort: 'Порт погрузки',
      transferPort: 'Порт пересадки',
      destinationPort: 'Порт назначения',
      warehousing: 'Склад',
      booking: 'Бронирование',
      entrust: 'Доверенность',
      container: 'Контейнер',
      distribution: 'Распределение',
      supplement: 'Дополнение'
    },
    pushingChannel: {
      all: 'Все',
      email: 'Email',
      msg: 'SMS'
    },
    sopTypes: {
      all: 'Все',
      sopSend: 'Отправка SOP',
      innerSend: 'Внутренняя отправка'
    },
    pushResult: {
      all: 'Все',
      success: 'Успешно',
      fail: 'Ошибка'
    },
    systemConstants: {
      SE: 'Морской экспорт',
      SI: 'Морской импорт',
      AE: 'Авиа экспорт',
      AI: 'Авиа импорт',
      RE: 'Желдор. эксп.',
      RI: 'Желдор. имп.',
      RB: 'Железнодорожный бизнес',
      IE: 'Интегрированная логистика',
      FBASE: 'FBA морской',
      FBAAE: 'FBA авиа',
      FBARE: 'FBA железнодорожный'
    },
    BillType: {
      MBL: 'Основной коносамент',
      HBL: 'Дополнительный коносамент'
    },
    importConstants: {
      FCL: 'FCL',
      LCL: 'LCL',
      CON: 'Консолидация',
      POJ: 'Проект',
      PVE: 'Личные вещи',
      ECL: 'Доверенная консолидация',
      BULK: 'Навалочный груз',
      CONSOLE: 'Один основной, много дополнительных',
      DIRECT: 'Прямой',
      BACK_TO_BACK: 'Один основной, один дополнительный'
    },
    airExportConstants: {
      CONSOLE: 'Один основной, много дополнительных',
      DIRECT: 'Прямой',
      BACK_TO_BACK: 'Один основной, один дополнительный'
    },
    seaExportConstants: {
      CONTRACT_STATE_NO: 'Не подписан',
      CONTRACT_STATE_OUT_OF_DATE: 'Контракт недействителен',
      CONTRACT_STATE_SIGNED: 'Подписан'
    },
    templateRuleName: {
      CUSTOMER_CN_NAME: 'Китайское название клиента',
      CUSTOMER_SHORT_NAME: 'Краткое название клиента',
      SETTLEMENT_CN_NAME: 'Китайское название расчетного объекта',
      SETTLEMENT_SHORT_NAME: 'Краткое название расчетного объекта',
      BOOKING_AGENT_CN_NAME: 'Китайское название агента бронирования',
      BOOKING_AGENT_SHORT_NAME: 'Краткое название агента бронирования',
      LOB_NO: 'Номер бизнеса',
      MBL_NO: 'MBL NO',
      HBL_NO: 'HBL NO',
      REF_NO: 'Номер декларации',
      BILL_NO: 'Номер счета',
      BILL_PAYMENT_NO: 'Номер платежа',
      WAREHOUSE_NO: 'Номер склада',
      PONO: 'Номер проекта',
      CUSTOMER_REF_NO: 'Ссылочный номер бизнеса',
      PLATE_NUMBER_DOOR: 'Номерной знак (текущая дверь)',
      PLATE_NUMBER_DEST: 'Номерной знак (текущее назначение)',
      CARRIER_CN_NAME: 'Китайское название судоходной компании',
      CARRIER_SHORT_NAME: 'Краткое название судоходной компании',
      ETD: 'Предполагаемая дата отправления',
      DESTINATION_PORT_CODE: 'Порт назначения',
      DESTINATION_PORT_CODE_CODE: 'Код порта назначения'
    },
    genDocCondition: {
      FormalHbl: 'Формальный HBL'
    },
    buttonName: {
      FormalHbl: 'Формальный HBL'
    }
  },
  parameter: {
    containerLoadType: {
      FCL: 'FCL',
      LCL: 'LCL',
      BB: 'Доверенная консолидация',
      BC: 'Buyer Console',
      BULK: 'Навалочный груз',
      SPA: 'Специальный контейнер'
    },
    partnerServiceItem: {
      ALL: 'Все',
      CUSTOMER: 'Клиент',
      BOOKING_AGENT: 'Агент бронирования',
      OVERSEA_AGENT: 'Агент в порту назначения',
      DESIGNATION_AGENT: 'Назначенный агент',
      LOCAL: 'Местный агент',
      SETTLEMENT_AGENT: 'Расчетный агент',
      SEA_CMP: 'Судоходная компания',
      AIR_CMP: 'Авиакомпания',
      SEA_CMP_AGENT: 'Судоходный агент',
      CUSTOMS_BROKER: 'Таможенный брокер',
      TRUCK_CMP: 'Грузовая компания',
      WAREHOUSE: 'Склад',
      GLOBAL: 'Глобальная компания',
      SHIPPER: 'Отправитель',
      CONSIGNEE: 'Получатель',
      NOTIFY: 'Уведомляемая сторона',
      PORT_AGENT: 'Портовый агент',
      FORWARDING_AGENT: 'Экспедитор',
      LOADINGPLACE_COMPANY: 'Компания места погрузки',
      SIGNBILLPLACE_COMPANY: 'Компания места подписания',
      DISCHARGEPORT_COMPANY: 'Компания порта выгрузки',
      DESTINATIONPORT_COMPANY: 'Компания порта назначения',
      OTHER: 'Другое'
    },
    roleType: {
      SALES_TYPE: 'Продажи',
      CSR_TYPE: 'Служба поддержки',
      DOC_TYPE: 'Документы',
      OVERSEAOP_TYPE: 'Зарубежная служба поддержки',
      SALES_OF_GOODS: 'Продажа товаров'
    }
  },
  advanceSearchForm: { // Компонент расширенного поиска
    ...ruRU,
    advSearchBtn: 'Расширенный поиск',
    quickSearch: 'Быстрый поиск',
    more: 'Больше условий',
    Equal: 'Равно',
    Unequal: 'Не равно',
    Greater: 'Больше',
    Less: 'Меньше',
    Like: 'Содержит',
    Not_Like: 'Не содержит',
    Batch: 'Пакет',
    BatchExclude: 'Исключить пакет',
    Regexp: 'Регулярное выражение',
    In: 'Входит в',
    Range: 'Диапазон',
    Not_In: 'Не входит в',
    Is_Not_Null: 'Не пусто',
    Is_Null: 'Пусто',
    Is_It_Empty: 'Пусто ли',
    Date_Item: 'Быстрый элемент',
    customer: { // Клиент
      level: 'Уровень клиента',
      chineseName: 'Китайское название',
      status: 'Статус клиента'
    },
    bookingNew: { // Экспресс-бронирование морских перевозок
      destinationCountry: 'Страна порта назначения',
      hblCheckingStatus: 'Статус проверки HBL',
      hblBlType: 'Тип HBL',
      hblBillOfLadingNumber: 'Номер HBL',
      hblReleasingStatus: 'Статус выпуска HBL',
      hblBlType2: 'Тип HBL',
      mblCheckingStatus: 'Статус проверки MBL',
      mblBlType: 'Тип MBL',
      mblBillOfLadingNumber: 'Номер MBL',
      overseaCustomerService: 'Зарубежная служба поддержки',
      customerLevel: 'Уровень клиента',
      isSignContract: 'Подписан ли контракт',
      userDefinedField1: 'Пользовательское поле 1',
      userDefinedField2: 'Пользовательское поле 2',
      userDefinedField3: 'Пользовательское поле 3',
      opOffice: 'Операционный офис',
      salesOffice: 'Офис продаж',
      bookingAgentIsNull: 'Агент бронирования пуст'
    },
    shortcut: 'Быстрые опции',
    daterange: 'Диапазон',
    lt: 'Меньше',
    gt: 'Больше',
    eq: 'Равно',
    notEq: 'Не равно',
    like: 'Содержит',
    draft: 'Черновик',
    commit: 'Отправить',
    check: 'Проверить',
    createDate: 'Дата создания',
    nowWeek: 'Эта неделя',
    preWeek: 'Прошлая неделя',
    nextWeek: 'Следующая неделя',
    nowMonth: 'Этот месяц',
    preMonth: 'Прошлый месяц',
    nextMonth: 'Следующий месяц',
    doubleClickToSelect: 'Дважды щелкните текстовое поле для выбора состояния узла',
    fitAll: 'Соответствует всем следующим',
    fitAny: 'Соответствует любому из следующих'
  },
  act: {
    billing: {
      pleaseSelectBilling: 'Пожалуйста, выберите счет!',
      hasConfirmed: 'Счет [{0}] подтвержден!',
      hasReviewed: 'Счет [{0}] проверен!',
      hasBillingGroup: 'Счет [{0}] уже включен в группу счетов!',
      hasInvoice: 'Счет [{0}] уже выставлен!',
      hasWriteOff: 'Счет [{0}] уже списан!',
      confirmDelete: 'Вы уверены, что хотите удалить эти {0} счетов?',
      noConfirmBill: 'Нет счетов для подтверждения!',
      noRecheckBill: 'Нет счетов для проверки!',
      noCancelRecheckBill: 'Нет счетов для отмены подтверждения!',
      batchConfirmBill: 'Вы уверены, что хотите подтвердить эти {0} счетов?',
      batchRecheckBill: 'Вы уверены, что хотите проверить эти {0} счетов?',
      noCancelConfirmBill: 'Нет счетов для отмены подтверждения!',
      confirmCancelBill: 'Вы уверены, что хотите отменить подтверждение этих {0} счетов?',
      cancelRecheckBill: 'Вы уверены, что хотите отменить проверку этих {0} счетов?',
      sameSettlementAgent: 'Счета должны иметь одного и того же расчетного агента!',
      hasBillingGroupNo: 'Группа счетов уже создана',
      noBillToBillingGroup: 'Нет счетов для создания группы счетов',
      confirmSuccess: 'Подтверждение успешно!',
      recheckSuccess: 'Проверка успешна!',
      cancelConfirmSuccess: 'Отмена подтверждения успешна',
      cancelRecheckSuccess: 'Отмена проверки успешна!',
      reconciliationAmountNotSupport: 'Введенная сумма сверки недопустима!',
      overseaHasPushed: '【{0}】Счет уже отправлен, удалить невозможно.',
      advDeleteConfirmTitle: 'Счет авансового платежа при сборе средств уже отправлен в Kingdee. Перед удалением убедитесь, что соответствующий документ удален в Kingdee.'
    },
    billingGroup: {
      hasConfirmed: 'Группа счетов [{0}] подтверждена!',
      hasReviewed: 'Группа счетов [{0}] проверена!',
      confirmDelete: 'Вы уверены, что хотите удалить эти {0} группы счетов?',
      billingNotNull: 'Счета не могут быть пустыми!',
      canNotRemoveAllBills: 'Нельзя удалить все счета!',
      settlementAgentNotNull: 'Расчетный агент счета [{0}] не может быть пустым!',
      settlementAgentAndAccountCanNotSame: 'Расчетный агент счета [{0}] не соответствует расчетному объекту группы счетов, пожалуйста, удалите этот счет перед сохранением!',
      validateAp: 'При типе поступлений "К получению" общая сумма счетов к получению не может быть меньше общей суммы счетов к оплате!',
      validateAr: 'При типе поступлений "К оплате" общая сумма счетов к оплате не может быть меньше общей суммы счетов к получению!',
      selectedBillingGroup: 'Пожалуйста, выберите группу счетов!',
      batchConfirmBillGroup: 'Вы уверены, что хотите подтвердить эти {0} группы счетов?',
      batchConfirmBill: 'Обновить статус счетов на "Подтверждено"?',
      noRecheckBillGroup: 'Нет групп счетов для проверки!',
      batchRecheckBillGroup: 'Вы уверены, что хотите проверить эти {0} группы счетов?',
      batchCancelRecheckBillGroup: 'Вы уверены, что хотите отменить проверку этих {0} групп счетов?',
      noCancelRecheckBillGroup: 'Нет групп счетов для отмены проверки!',
      noCancelConfirmBillGroup: 'Группа счетов уже проверена, нельзя отменить подтверждение!'
    }
  },
  grid: {
    resetSort: 'Сбросить сортировку',
    restColumns: 'Сбросить столбцы',
    autoSizeColumns: 'Автоматически изменить размер всех столбцов',
    pinLeftAll: 'Закрепить все столбцы слева',
    subtotal: 'Промежуточный итог',
    groupedSubtotal: 'Подсчет по группам',
    summaryMode: 'Режим итогов',
    count: 'Подсчет',
    sum: 'Сумма'
  }
}
// agGrid таблица
export const i18n_ag_grid = {
  // для панели фильтров
  page: 'Страница',
  more: 'Еще',
  to: '-',
  of: 'из',
  next: 'Следующая страница',
  last: 'Последняя страница',
  first: 'Первая страница',
  previous: 'Предыдущая',
  loadingOoo: 'Загрузка...',

  // для набора фильтров
  selectAll: 'Выбрать все',
  searchOoo: 'Поиск...',
  blanks: 'Пустые',

  // для числового фильтра и текстового фильтра
  filterOoo: 'Фильтр...',
  applyFilter: 'Применить фильтр...',

  // для числового фильтра
  equals: 'Равно',
  lessThan: 'Меньше',
  greaterThan: 'Больше',

  // для текстового фильтра
  contains: 'Содержит',
  startsWith: 'Начинается с',
  endsWith: 'Заканчивается на',

  // заголовок столбца группы по умолчанию
  group: 'Группировка данных',

  // панель инструментов
  columns: 'Настройка столбцов',
  filters: 'Фильтры',
  rowGroupColumns: 'Столбцы группировки строк',
  rowGroupColumnsEmptyMessage: 'Перетащите имена столбцов сюда для группировки данных (текущая страница)',
  valueColumns: 'Столбцы значений',
  pivotMode: 'Режим сводной таблицы',
  groups: 'Группировка данных',
  values: 'Значения',
  pivots: 'Сводные таблицы',
  valueColumnsEmptyMessage: 'Сообщение о пустых столбцах значений',
  pivotColumnsEmptyMessage: 'Сообщение о пустых столбцах сводной таблицы',
  toolPanelButton: 'Кнопка панели инструментов',

  // другое
  noRowsToShow: 'Нет результатов поиска',

  // корпоративное меню
  pinColumn: 'Закрепить столбец',
  valueAggregation: 'Агрегация значений',
  autosizeThiscolumn: 'Автоматически изменить размер этого столбца',
  autosizeAllColumns: 'Автоматически изменить размер всех столбцов',
  groupBy: 'Группировать по',
  ungroupBy: 'Отменить группировку',
  resetColumns: 'Сбросить',
  expandAll: 'Развернуть все',
  collapseAll: 'Свернуть все',
  toolPanel: 'Панель инструментов',
  'export': 'Экспорт',
  csvExport: 'CSV ',
  excelExport: 'Excel ',

  // корпоративное меню закрепления
  pinLeft: 'Закрепить слева',
  pinRight: 'Закрепить справа',
  noPin: 'Не закреплять <>',

  // корпоративное меню агрегации и панель состояния
  sum: 'Сумма',
  min: 'Минимум',
  max: 'Максимум',
  none: 'Нет',
  count: 'Подсчет',
  average: 'Среднее',

  // стандартное меню
  copy: 'Копировать',
  copyWithHeaders: 'Копировать с заголовками',
  ctrlC: 'ctrl + C',
  paste: 'Вставить',
  ctrlV: 'ctrl + V',

  // Набор фильтров
  selectAllSearchResults: '(Выбрать все результаты поиска)',
  noMatches: 'Нет совпадений',

  // Числовой фильтр и текстовый фильтр
  notEqual: 'Не равно',
  empty: 'Пожалуйста, выберите',

  // Числовой фильтр
  lessThanOrEqual: 'Меньше или равно',
  greaterThanOrEqual: 'Больше или равно',
  inRange: 'В диапазоне',
  inRangeStart: 'от',
  inRangeEnd: 'до',

  // Текстовый фильтр
  notContains: 'Не содержит',

  // Фильтр даты
  dateFormatOoo: 'гггг-мм-дд',

  // Условия фильтра
  andCondition: 'И',
  orCondition: 'ИЛИ',

  // Кнопки фильтра
  resetFilter: 'Сбросить',
  clearFilter: 'Очистить',
  cancelFilter: 'Отмена',

  // Заголовки фильтров
  textFilter: 'Текстовый фильтр',
  numberFilter: 'Числовой фильтр',
  dateFilter: 'Фильтр даты',
  setFilter: 'Набор фильтров',

  // Другое
  enabled: 'Активировано',
  // Корпоративное меню агрегации и строка состояния
  avg: 'Среднее',
  filteredRows: 'Отфильтровано',
  selectedRows: 'Выбрано',
  totalRows: 'Всего строк',
  totalAndFilteredRows: 'Строк',
  nextPage: 'Следующая страница',
  lastPage: 'Последняя страница',
  firstPage: 'Первая страница',
  previousPage: 'Предыдущая страница',

  // Корпоративное меню (Диаграммы)
  pivotChartAndPivotMode: 'Сводная диаграмма и режим сводной таблицы',
  pivotChart: 'Сводная диаграмма',
  chartRange: 'Диапазон диаграммы',

  columnChart: 'Столбчатая диаграмма',
  groupedColumn: 'Сгруппировано',
  stackedColumn: 'Сложено',
  normalizedColumn: '100% сложено',

  barChart: 'Гистограмма',
  groupedBar: 'Сгруппировано',
  stackedBar: 'Сложено',
  normalizedBar: '100% сложено',

  pieChart: 'Круговая диаграмма',
  pie: 'Круговая',
  doughnut: 'Кольцевая',

  line: 'Линейная',

  xyChart: 'X Y (Точечная)',
  scatter: 'Точечная',
  bubble: 'Пузырьковая',

  areaChart: 'Областная диаграмма',
  area: 'Область',
  stackedArea: 'Сложено',
  normalizedArea: '100% сложено',

  histogramChart: 'Гистограмма',

  // Диаграммы
  pivotChartTitle: 'Сводная диаграмма',
  rangeChartTitle: 'Диаграмма диапазона',
  settings: 'Настройки',
  data: 'Данные',
  format: 'Формат',
  categories: 'Категории',
  defaultCategory: '(Нет)',
  series: 'Серии',
  xyValues: 'X Y значения',
  paired: 'Парный режим',
  axis: 'Ось',
  navigator: 'Навигатор',
  color: 'Цвет',
  thickness: 'Толщина',
  xType: 'Тип X',
  automatic: 'Автоматически',
  category: 'Категория',
  number: 'Число',
  time: 'Время',
  xRotation: 'Поворот X',
  yRotation: 'Поворот Y',
  ticks: 'Деления',
  width: 'Ширина',
  height: 'Высота',
  length: 'Длина',
  padding: 'Отступ',
  spacing: 'Интервал',
  chart: 'Диаграмма',
  title: 'Заголовок',
  titlePlaceholder: 'Заголовок диаграммы - дважды щелкните для редактирования',
  background: 'Фон',
  font: 'Шрифт',
  top: 'Верх',
  right: 'Право',
  bottom: 'Низ',
  left: 'Лево',
  labels: 'Метки',
  size: 'Размер',
  minSize: 'Минимальный размер',
  maxSize: 'Максимальный размер',
  legend: 'Легенда',
  position: 'Положение',
  markerSize: 'Размер маркера',
  markerStroke: 'Обводка маркера',
  markerPadding: 'Отступ маркера',
  itemSpacing: 'Интервал элементов',
  itemPaddingX: 'Отступ элементов X',
  itemPaddingY: 'Отступ элементов Y',
  layoutHorizontalSpacing: 'Горизонтальный интервал',
  layoutVerticalSpacing: 'Вертикальный интервал',
  strokeWidth: 'Ширина обводки',
  offset: 'Смещение',
  offsets: 'Смещения',
  tooltips: 'Подсказки',
  callout: 'Выноска',
  markers: 'Маркеры',
  shadow: 'Тень',
  blur: 'Размытие',
  xOffset: 'Смещение X',
  yOffset: 'Смещение Y',
  lineWidth: 'Ширина линии',
  normal: 'Обычный',
  bold: 'Жирный',
  italic: 'Курсив',
  boldItalic: 'Жирный курсив',
  predefined: 'Предопределенный',
  fillOpacity: 'Прозрачность заливки',
  strokeOpacity: 'Прозрачность обводки',
  histogramBinCount: 'Количество бинов',
  columnGroup: 'Столбчатая диаграмма',
  barGroup: 'Гистограмма',
  pieGroup: 'Круговая диаграмма',
  lineGroup: 'Линейная диаграмма',
  scatterGroup: 'X Y (Точечная)',
  areaGroup: 'Областная диаграмма',
  histogramGroup: 'Гистограмма',
  groupedColumnTooltip: 'Сгруппировано',
  stackedColumnTooltip: 'Сложено',
  normalizedColumnTooltip: '100% сложено',
  groupedBarTooltip: 'Сгруппировано',
  stackedBarTooltip: 'Сложено',
  normalizedBarTooltip: '100% сложено',
  pieTooltip: 'Круговая диаграмма',
  doughnutTooltip: 'Кольцевая диаграмма',
  lineTooltip: 'Линейная диаграмма',
  groupedAreaTooltip: 'Сгруппировано',
  stackedAreaTooltip: 'Сложено',
  normalizedAreaTooltip: '100% сложено',
  scatterTooltip: 'Точечная диаграмма',
  bubbleTooltip: 'Пузырьковая диаграмма',
  histogramTooltip: 'Гистограмма',
  noDataToChart: 'Нет данных для построения диаграммы.',
  pivotChartRequiresPivotMode: 'Для сводной диаграммы необходимо включить режим сводной таблицы.',
  chartSettingsToolbarTooltip: 'Меню',
  chartLinkToolbarTooltip: 'Связать с диаграммой',
  chartUnlinkToolbarTooltip: 'Отменить связь с диаграммой',
  chartDownloadToolbarTooltip: 'Скачать диаграмму',

  // ARIA
  ariaHidden: 'Скрыто',
  ariaVisible: 'Видимо',
  ariaChecked: 'Отмечено',
  ariaUnchecked: 'Не отмечено',
  ariaIndeterminate: 'Неопределенно',
  ariaColumnSelectAll: 'Переключить выбор всех столбцов',
  ariaInputEditor: 'Редактор ввода',
  ariaDateFilterInput: 'Фильтр по дате',
  ariaFilterInput: 'Ввод фильтра',
  ariaFilterColumnsInput: 'Ввод столбцов фильтра',
  ariaFilterValue: 'Значение фильтра',
  ariaFilterFromValue: '-от-значения фильтра',
  ariaFilterToValue: '-до-значения фильтра',
  ariaFilteringOperator: 'Оператор фильтрации',
  ariaColumnToggleVisibility: 'Переключить видимость столбца',
  ariaColumnGroupToggleVisibility: 'Переключить видимость группы столбцов',
  ariaRowSelect: 'Нажмите пробел для выбора этой строки',
  ariaRowDeselect: 'Нажмите пробел для отмены выбора этой строки',
  ariaRowToggleSelection: 'Нажмите пробел для переключения выбора строки',
  ariaRowSelectAll: 'Нажмите пробел для переключения выбора всех строк',
  ariaSearch: 'Поиск',
  ariaSearchFilterValues: 'Поиск значений фильтра'
}
